import styled from 'styled-components';
import Button, {
  ButtonProps,
} from '@grnhse/seedling/lib/azalea/components/button';

const EditButton = styled(Button)<ButtonProps>`
  display: block;
  margin: 0 0 0 25px;
  padding: 0;
  width: fit-content;
`;

export default EditButton;
